import { render, staticRenderFns } from "./list_pengajuan.vue?vue&type=template&id=7c1e3ece"
import script from "./list_pengajuan.vue?vue&type=script&lang=js"
export * from "./list_pengajuan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QCard,QCardSection,QSelect,QInput,QBtn,QBtnGroup,QTooltip,QPagination,QDialog,QToggle,QCardActions,QIcon,QSeparator,QImg,QList,QItem,QItemSection,QBadge,QFile,ClosePopup} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QCard,QCardSection,QSelect,QInput,QBtn,QBtnGroup,QTooltip,QPagination,QDialog,QToggle,QCardActions,QIcon,QSeparator,QImg,QList,QItem,QItemSection,QBadge,QFile})
component.options.directives = Object.assign(Object.create(component.options.directives || null), component.options.directives || {}, {ClosePopup})
